// What Neo's status rules say about the home page's scene (TOM-552). The page
// draws Gallivant's record (gallivant.ts), and its headline, Neo's answer, the
// anchor card and the morning report's anchor row all come from here, so the
// scene can't say the anchor is holding where the rules would not.
//
// The thresholds are the anchor watch's (cloud/src/core/anchor/watch-status.ts):
// drag suspected from 85% of the circle, outside it at 100%. The web's own watch
// band (lib/overviewWatch.ts) is the same. The headlines are the ones Neo's status
// composes for them (cloud/src/core/neo-status/compose.ts).

/** The share of the anchor circle at which the watch reads "drag suspected". */
export const ANCHOR_CAUTION_SHARE = 0.85;

export type SceneAnchor = 'holding' | 'drag_suspected' | 'outside';

/** How the anchor watch reads a distance from the anchor in a circle of this radius. */
export function sceneAnchor(distanceM: number, radiusM: number): SceneAnchor {
  const share = distanceM / radiusM;
  if (share >= 1) return 'outside';
  if (share >= ANCHOR_CAUTION_SHARE) return 'drag_suspected';
  return 'holding';
}

export interface SceneHeadline {
  tone: 'calm' | 'caution' | 'alarm';
  text: string;
}

/** Neo's headline for the anchor, as the status rules write it. */
export function sceneHeadline(anchor: SceneAnchor, boat: string): SceneHeadline {
  switch (anchor) {
    case 'outside':
      return { tone: 'alarm', text: `${boat} is outside the anchor circle.` };
    case 'drag_suspected':
      return { tone: 'caution', text: 'The anchor may be dragging.' };
    case 'holding':
      return { tone: 'calm', text: 'All normal. The anchor is holding.' };
  }
}

/** The anchor card's status label. */
export const SCENE_ANCHOR_LABEL: Record<SceneAnchor, string> = {
  holding: 'Holding',
  drag_suspected: 'May be dragging',
  outside: 'Outside the circle',
};
